LiveForm.setOptions({
    messageErrorPrefix: '&nbsp;<i class="icon-exclamation-outline" aria-hidden="true"></i>&nbsp;',
    messageErrorClass: 'form-text text-danger',
    messageTag: 'div'
});

// Custom validator for Latin-safe characters. Whitelist approach: everything not explicitly
// allowed (any non-Latin script, emoji, * ` ^ ~) is rejected.
// MUST stay in sync with BaseForm::LATIN_SAFE_PATTERN in app/formControls/BaseForm.php.
// Note: Nette replaces :: with _ in validator names
Nette.validators.BaseForm_validateLatinSafe = function(elem, arg, val) {
    if (val === '' || val === null) {
        return true;
    }
    // Check for 2+ dots at start or end
    if (/^\.{2,}|\.{2,}$/.test(val)) {
        return false;
    }
    return /^[A-Za-z0-9\u00C0-\u024F\u1E00-\u1EFF \t\r\n\u00A0.,;:!?'"()\[\]{}\/\\_@&+#%=<>$\u00A3\u00A7\u00AB\u00BB\u00B0-\u00B5\u00BC-\u00BE\u20AC\u2013\u2014\u2018-\u201F\u2026-]*$/.test(val);
};
